import { FormikValues } from 'formik'
import { debounce } from 'lodash'
import { useEffect, useMemo, useState } from 'react'
import { Maybe, useInterventionsLazyQuery } from '../generated/graphql'

export default function useInterventionDuplicateChecker() {
    const [params, setParams] = useState<Maybe<{ id: string, week: number, year: number }>>()
    const [check, { data, loading }] = useInterventionsLazyQuery()

    useEffect(() => {
        if (params?.id && params?.week && params?.year) {
            check({
                variables: {
                    filter: {
                        state: { in: ["PREPARATION", "SUBMITTED", "REVIEW"] },
                        week: { eq: params.week },
                        year: { eq: params.year },
                        workPermit: { id: { eq: params.id } },
                    }
                }
            })
        }
    }, [params?.id, params?.week, params?.year, check])

    const debouncedSetParams = useMemo(
        () => debounce((newParams: { id: string, week: number, year: number }) => {
            setParams(prev => {
                if (prev?.id === newParams.id &&
                    prev?.week === newParams.week &&
                    prev?.year === newParams.year) {
                    return prev
                }
                return newParams
            })
        }, 500),
        []
    )

    const checkForDuplicates = (values: FormikValues) => {
        const { workPermit, week, year } = values

        if (workPermit?.id && week && year) {
            debouncedSetParams({ id: workPermit.id, week, year })
        }
    }

    return {
        checkForDuplicates,
        matchedInterventions: data,
        loading
    }
}
